import React from 'react'
import PropTypes from 'prop-types'
import ExportChoiceCards from './ExportChoiceCards'

const PDFChoiceOptions = ({ onExportAll, onCustomize }) => (
  <ExportChoiceCards
    exportAllTitle="Tout exporter"
    exportAllDescription="Exportez toutes les sections des ressources dans un fichier ZIP de PDF."
    customizeDescription="Sélectionnez des sections et questions spécifiques pour un export ciblé."
    onExportAll={onExportAll}
    onCustomize={onCustomize}
  />
)

PDFChoiceOptions.propTypes = {
  onCustomize: PropTypes.func.isRequired,
  onExportAll: PropTypes.func.isRequired
}

export default PDFChoiceOptions
